import React, {FC} from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { AdminInventoryActivitySearchCriteria } from "../../../types/model/criteria/inventoryActivity/AdminInventoryActivitySearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  AdminInventoryActivitySortByType,
  AdminInventoryActivitySortParams
} from "../../../types/model/params/sortParams/AdminInventoryActivitySortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundDatePicker,
  BoundAssetTypeAutocomplete,
  BoundGateEventTypeSelect,
  BoundTextInput
} from "../../common/inputs/boundInputs";

export interface AdminInterchangesSearchParams extends AdminInventoryActivitySearchCriteria, AdminInventoryActivitySortParams, PageableParams, BoundSearchQuery {}

export interface AdminInterchangesSortFilterProps {
  query: AdminInterchangesSearchParams;
  onChange: (newQuery: AdminInterchangesSearchParams) => void;
}

const AdminInterchangesSortFilter: FC<AdminInterchangesSortFilterProps> = ({
  query,
  onChange
}) => {

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminInterchangesSearchParams>
          label="Location"
          requestUrl={optionsEndpoints.admin.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminInterchangesSearchParams>
          label="Supplier"
          requestUrl={optionsEndpoints.admin.account.supplier}
          name="supplierId"
          value={query?.supplierId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<AdminInterchangesSearchParams>
          label="Buyer"
          requestUrl={optionsEndpoints.admin.account.buyer}
          name="buyerId"
          value={query?.buyerId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<AdminInterchangesSearchParams>
          label="Booking Number"
          name="bookingNumber"
          value={query?.bookingNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundTextInput<AdminInterchangesSearchParams>
          label="Equipment Number"
          name="equipmentNumber"
          value={query?.equipmentNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDatePicker<AdminInterchangesSearchParams>
          label="Start Date"
          name="startDate"
          value={query?.startDate}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDatePicker<AdminInterchangesSearchParams>
          label="End Date"
          name="endDate"
          value={query?.endDate}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<AdminInterchangesSearchParams>
          label="Driver Name"
          name="driverName"
          value={query?.driverName}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundAssetTypeAutocomplete<AdminInterchangesSearchParams>
          name="equipmentType"
          value={query?.equipmentType}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundGateEventTypeSelect<AdminInterchangesSearchParams>
          name="activity"
          value={query?.activity}
          onChange={onChange}
        />
      </SortFilterItemContainer>

      <SortFilterItemContainer>
        <BoundSortSelect<AdminInterchangesSearchParams, AdminInventoryActivitySortByType>
          query={query}
          defaultSortBy="ACTIVITY_DATE"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { AdminInterchangesSortFilter };
